import { useMutation } from "@apollo/client";
import { graphql } from "../gql";
import { GetAllProgressCheckPdfsQuery } from "./useAllProgressCheckPdfs.ts";
import { SpeakingClassLevel } from "../gql/graphql.ts";

const CreateProgressCheckPdfMutation = graphql(`
  mutation createProgressCheckPdf(
    $level: SpeakingClassLevel!
    $pdfUrl: String!
    $userGroupId: String!
  ) {
    createProgressCheckPdf(
      level: $level
      pdfUrl: $pdfUrl
      userGroupId: $userGroupId
    ) {
      level
      pdfUrl
      userGroupId
      userGroup {
        id
        name
      }
    }
  }
`);

export function useCreateProgressCheckPdf() {
  const [mutate, { loading }] = useMutation(CreateProgressCheckPdfMutation, {
    refetchQueries: [GetAllProgressCheckPdfsQuery],
  });

  return {
    loading,
    create: (input: {
      level: SpeakingClassLevel;
      pdfUrl: string;
      userGroupId: string;
    }) =>
      mutate({
        variables: input,
      }),
  };
}
